import {IBreadCrumbState, UpdateBreadCrumbAction, TBreadcrumb} from "../../types/redux/breadcrumb";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import * as Constants from "../../constants";
import Utils from "../../utils";

const initialState: IBreadCrumbState = {
  breadcrumbs: [{
    label:  Utils.toTitleCase(Constants.HOME),
    href: '/' + Constants.HOME.toLowerCase(),
    level: 0,
    active: false
  }]
};

const resetToCrumb = (state: IBreadCrumbState, crumb: TBreadcrumb) => {
  for (let i=0; i<state.breadcrumbs.length; i++) {
    if (!state.breadcrumbs[i]) {
      console.warn('null breadcrumb')
    } else {
      state.breadcrumbs[i].active = false;
    }
  }

  const pos: number = state.breadcrumbs.findIndex(stateCrumb => stateCrumb.level >= crumb?.level);
  if (pos > -1) {
    state.breadcrumbs = state.breadcrumbs.slice(0, pos);
  }

  const crumbClone: TBreadcrumb = {...crumb};
  crumbClone.active = true;
  state.breadcrumbs.push(crumbClone);
}

export const breadcrumbSlice = createSlice({
  name: UpdateBreadCrumbAction,
  initialState: initialState,
  reducers: {
    addCrumb: (state: IBreadCrumbState, action: PayloadAction<TBreadcrumb>) => {
      resetToCrumb(state, action.payload)
    },

    removeToCrumb: (state: IBreadCrumbState, action: PayloadAction<TBreadcrumb>) => {
      resetToCrumb(state, {...action.payload});
    },

    removeLastCrumb: (state: IBreadCrumbState) => {
      const prevCrumb: TBreadcrumb = {...state.breadcrumbs[state.breadcrumbs.length - 1]};
      if (prevCrumb) {
        resetToCrumb(state, prevCrumb);
      }
    },

    clearCrumbs: (state: IBreadCrumbState) => {
      state.breadcrumbs = [];
    }
  }
});

export const {
  addCrumb,
  removeToCrumb,
  removeLastCrumb,
  clearCrumbs
} = breadcrumbSlice.actions;
export default breadcrumbSlice.reducer;
